import {
  Component,
  ComponentRef,
  Injector,
  Input,
  OnInit,
  Type,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation,
} from '@angular/core';
import { ComponentRenderer } from '../../renderers/component-renderer';
import { DefaultFilterLabelRendererComponent } from './default-filter-label.component';
import { FilterRenderer } from './filter-renderer';
import { Filter } from '../filters';
import { CommonModule } from '@angular/common';
import { AbstractControl, FormGroup } from '@angular/forms';

/**
 * Component that dynamically renders configured CellRenderer components to Columns
 */
@Component({
  selector: 'cbre-filter-label-renderer',
  template: `<ng-container #Container></ng-container> `,
  imports: [CommonModule, DefaultFilterLabelRendererComponent],
  encapsulation: ViewEncapsulation.None,
})
export class FilterLabelRendererComponent<T extends Filter> implements OnInit, ComponentRenderer<FilterRenderer<T>> {
  private _filter: T;
  /**
   * config
   */
  @Input() public set filter(cfg: T) {
    this._filter = cfg;
    if (this.input && this.input.instance) {
      this.input.instance.filter = this._filter;
    }
  }
  public get filter() {
    return this._filter;
  }

  private _form: FormGroup;
  @Input() public set form(form: AbstractControl) {
    this._form = form as FormGroup;
    if (this.input && this.input.instance) {
      this.input.instance.form = this._form;
    }
  }

  /**
   * ContainerRef to render the configured CellRenderer<T> type
   */
  @ViewChild('Container', { read: ViewContainerRef, static: true }) private container: ViewContainerRef;

  public input: ComponentRef<FilterRenderer<T>>;

  constructor(protected parentInjector: Injector) {}

  ngOnInit(): void {
    const rendererType: Type<FilterRenderer<any>> = this.resolveComponentType();
    this.mountComponent(rendererType);
  }

  public resolveComponentType(): Type<FilterRenderer<any>> {
    return this.filter.LabelRenderer ?? this.getDefaultComponent();
  }

  public getDefaultComponent(): Type<FilterRenderer<any>> {
    return DefaultFilterLabelRendererComponent;
  }

  public mountComponent(component: Type<FilterRenderer<T>>) {
    this.input = this.container.createComponent(component, { injector: this.parentInjector });
    this.input.instance.filter = this._filter;
    this.input.instance.form = this._form;
  }
}
